function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 511.998 511.998",
  style: {
    "enableBackground": "new 0 0 511.998 511.998"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#CEE8FA"
  },
  points: "351.38,16.284 347.586,16.284 347.586,122.034 464.78,122.034 \t"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#CEE8FA"
  },
  points: "44.666,208.782 44.666,306.488 184.933,306.488 184.933,370.87 326.573,255.999  184.933,141.13 184.933,208.782 \t"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#00acea"
  },
  d: "M467.331,202.728c-8.994,0-16.284,7.29-16.284,16.284v260.42H105.826v-156.66h62.825v48.098 c0,6.279,3.61,12,9.279,14.7c2.231,1.063,4.623,1.584,7.002,1.584c3.667,0,7.302-1.238,10.259-3.636l141.64-114.871 c3.812-3.091,6.027-7.738,6.027-12.648c0-4.91-2.215-9.555-6.027-12.648l-141.64-114.871c-4.877-3.955-11.593-4.753-17.263-2.052 c-5.668,2.702-9.279,8.42-9.279,14.7v51.368H44.668c-8.994,0-16.284,7.29-16.284,16.284v97.706c0,8.994,7.29,16.284,16.284,16.284 h28.59v172.944c0,8.994,7.29,16.284,16.284,16.284h377.789c8.994,0,16.284-7.29,16.284-16.284V219.012 C483.615,210.018,476.324,202.728,467.331,202.728z M60.952,225.066h123.983c8.994,0,16.284-7.29,16.284-16.284v-33.48 l99.503,80.697l-99.503,80.697v-30.208c0-8.994-7.29-16.284-16.284-16.284H60.952V225.066z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#00acea"
  },
  d: "M89.542,138.318c8.994,0,16.284-7.29,16.284-16.284V32.568h225.476v89.466 c0,8.994,7.29,16.284,16.284,16.284H464.78c6.689,0,12.698-4.092,15.151-10.316c2.452-6.224,0.848-13.315-4.045-17.878 L362.488,4.376c-0.124-0.116-0.259-0.217-0.386-0.327c-0.192-0.168-0.383-0.335-0.583-0.493c-0.2-0.16-0.405-0.309-0.612-0.458 c-0.217-0.156-0.432-0.311-0.656-0.458c-0.199-0.129-0.402-0.248-0.606-0.368c-0.246-0.147-0.493-0.29-0.747-0.423 c-0.191-0.099-0.386-0.187-0.58-0.28c-0.275-0.13-0.55-0.261-0.835-0.375c-0.189-0.077-0.383-0.14-0.575-0.21 c-0.295-0.106-0.588-0.213-0.889-0.303c-0.207-0.062-0.417-0.107-0.625-0.161c-0.291-0.073-0.58-0.153-0.878-0.21 c-0.267-0.052-0.537-0.085-0.806-0.124c-0.246-0.034-0.489-0.081-0.738-0.104C352.445,0.029,351.914,0,351.38,0h-3.794H89.542 c-8.994,0-16.284,7.29-16.284,16.284v105.75C73.258,131.028,80.548,138.318,89.542,138.318z M363.87,105.75V50.197l59.572,55.553 H363.87z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/import.6ff25b35.svg";
export { SvgComponent as ReactComponent };